export function getAtarText(val) {
  return val ? (val < 30 ? "< 30" : val) : "< 30";
}

export const ATAR_TOOL_MIN_SCORE = 29.95;
